import { useQuery } from "@tanstack/react-query";
import { useApiClient } from "@src/packages/api/louise-api";
import { throwApiError } from "@src/packages/api/api-error";
import type { paths } from "@src/packages/openapi/schema";

export type FETParticipantView =
  paths["/patients/{patientId}/frozen-embryo-transfer-participant-views"]["get"]["responses"]["200"]["content"]["application/json"]["data"][number];

export function fetParticipantViewsQueryKey(patientId: string | null) {
  return ["fet-participant-views", patientId] as const;
}

export function useFETParticipantViews(options?: { enabled?: boolean }) {
  const { client, patientId } = useApiClient();
  const enabled = options?.enabled ?? true;

  return useQuery<FETParticipantView[]>({
    queryKey: fetParticipantViewsQueryKey(patientId),
    queryFn: async () => {
      if (!patientId) return [];
      const { data, error } = await client.GET(
        "/patients/{patientId}/frozen-embryo-transfer-participant-views",
        { params: { path: { patientId } } },
      );
      if (error) {
        throwApiError(
          error,
          "Failed to load FET participant tasks",
          "fet-participant-views",
        );
      }
      return data?.data ?? [];
    },
    enabled: enabled && !!patientId,
  });
}
